module.exports = __webpack_public_path__ + "img/fc_logo.607b3a73.png";